'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fecha = require('fecha');

var _fecha2 = _interopRequireDefault(_fecha);

var _logLevelConstants = require('./../log-level-constants');

var _logLevelConstants2 = _interopRequireDefault(_logLevelConstants);

var _abstract_logger = require('./abstract_logger');

var _abstract_logger2 = _interopRequireDefault(_abstract_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-named-as-default


/* global cordova */
module.exports = function (_AbstractLogger) {
  _inherits(CordovaFileLogger, _AbstractLogger);

  function CordovaFileLogger(_ref) {
    var minimumLogLevel = _ref.minimumLogLevel,
        logfileRotationCount = _ref.logfileRotationCount;

    _classCallCheck(this, CordovaFileLogger);

    var _this = _possibleConstructorReturn(this, (CordovaFileLogger.__proto__ || Object.getPrototypeOf(CordovaFileLogger)).call(this, minimumLogLevel));

    _this.logfileRotationCount = logfileRotationCount;
    _this.iswriting = false;
    return _this;
  }

  _createClass(CordovaFileLogger, [{
    key: 'write',
    value: function write(properties) {
      var _this2 = this;

      if (!window.cordova) {
        throw new Error('Could not log to file. Cordova not accessible');
      }

      var timestamp = new Date();

      this.checkIfRotationIsNeeded().then(function () {
        return _this2.writeToFile(Object.assign(properties, { timestamp: timestamp }));
      }).catch(function (err) {
        throw new Error(err);
      });

      return true;
    }
  }, {
    key: 'listDir',
    value: function listDir(path) {
      return new Promise(function (resolve, reject) {
        window.resolveLocalFileSystemURL(path, function (fileSystem) {
          var reader = fileSystem.createReader();
          reader.readEntries(function (entries) {
            resolve(entries);
          }, function (err) {
            reject(err);
          });
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: 'checkIfRotationIsNeeded',
    value: function checkIfRotationIsNeeded() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        try {
          var today = new Date();
          var checkDate = new Date();

          var lastCheckedDate = window.localStorage.getItem('dlw-last-logfile-checked-date');

          // only do the rotation once a day.
          if (!lastCheckedDate || new Date(lastCheckedDate) < checkDate.setDate(today.getDate() - 1)) {
            // if we already checked today, skip the rotating mechanism.
            _this3.rotateFiles().then(function () {
              window.localStorage.setItem('dlw-last-logfile-checked-date', today);
              resolve();
            }).catch(reject);
          }

          // When no rotating is needed, resolve promise
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    }
  }, {
    key: 'getLoglevelFromValue',
    value: function getLoglevelFromValue(val) {
      return Object.keys(_logLevelConstants2.default).find(function (key) {
        return _logLevelConstants2.default[key] === val;
      });
    }
  }, {
    key: 'writeToFile',
    value: function writeToFile(_ref2) {
      var _this4 = this,
          _arguments = arguments;

      var message = _ref2.message,
          level = _ref2.level,
          _ref2$properties = _ref2.properties,
          properties = _ref2$properties === undefined ? {} : _ref2$properties,
          _ref2$measurements = _ref2.measurements,
          measurements = _ref2$measurements === undefined ? {} : _ref2$measurements,
          _ref2$severityLevel = _ref2.severityLevel,
          severityLevel = _ref2$severityLevel === undefined ? 3 : _ref2$severityLevel,
          _ref2$handledAt = _ref2.handledAt,
          handledAt = _ref2$handledAt === undefined ? '' : _ref2$handledAt,
          _ref2$time = _ref2.time,
          time = _ref2$time === undefined ? new Date() : _ref2$time;

      // if a writer is already writing to the file, wait for 200ms
      if (this.iswriting) {
        return new Promise(function (resolve, reject) {
          setTimeout(function () {
            return _this4.writeToFile.apply(_this4, _arguments).then(resolve()).catch(reject());
          }, 200);
        });
      }

      return new Promise(function (resolve, reject) {
        try {
          _this4.iswriting = true;
          window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function (directoryEntry) {
            directoryEntry.getFile(_fecha2.default.format(time, 'DD_MM_YYYY') + '.log', {
              create: true
            }, function (fileEntry) {
              fileEntry.createWriter(function (writer) {
                // Goto end of file and write the newest loginfo in the .log file
                writer.seek(writer.length);

                var levelName = _this4.getLoglevelFromValue(level).toUpperCase();
                var timestamp = _fecha2.default.format(time, 'HH:mm:ss');

                var log = '\n[' + timestamp + '] ' + levelName + ' -  ' + message + '\nProperties: ' + JSON.stringify(properties) + '\nMeasurements: ' + JSON.stringify(measurements) + '\nSeverityLevel: ' + severityLevel + '\nHandledAt: ' + handledAt;
                var blob = new Blob([log], { type: 'text/plain' });
                writer.write(blob);
                _this4.iswriting = false;
                resolve();
              }, function (err) {
                _this4.iswriting = false;
                reject(err);
              });
            }, function (err) {
              _this4.iswriting = false;
              reject(err);
            });
          }, function (evt) {
            _this4.iswriting = false;
            reject(evt.target.error);
          });
        } catch (err) {
          _this4.iswriting = false;
          reject(err);
        }
      });
    }
  }, {
    key: 'deleteFile',
    value: function deleteFile(fileEntry) {
      return new Promise(function (resolve, reject) {
        fileEntry.remove(function () {
          resolve();
        }, function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'rotateFiles',
    value: function rotateFiles() {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        // get a list of all entries
        try {
          var today = new Date();
          var oldestAcceptableDay = today.setDate(today.getDate() - _this5.logfileRotationCount);

          _this5.listDir(cordova.file.dataDirectory).then(function (entries) {
            var rotateLogFilePromises = entries.reduce(function (promises, entry) {
              if (entry && entry.name) {
                var date = _fecha2.default.parse(entry.name.split('.log')[0], 'DD_MM_YYYY');
                if (date && date < new Date(oldestAcceptableDay)) {
                  return [].concat(_toConsumableArray(promises), [_this5.deleteFile(entry)]);
                }
              }
              return promises;
            }, []);

            rotateLogFilePromises.reduce(function (acc, p) {
              return acc.then(function () {
                return p();
              });
            }, Promise.resolve()).then(resolve).catch(function (error) {
              reject(error);
            });
          });
        } catch (err) {
          reject(err);
        }
      });
    }
  }]);

  return CordovaFileLogger;
}(_abstract_logger2.default);